import { NavLink } from "react-router-dom";
import { MdArrowBackIos } from "react-icons/md";
import { cn } from "../../../utils/constants/cn";
import { SidebarUpContent, SidebarUpContentForPaymentCollector } from "../../../Objects/main";
import { TriggerStore } from "../../../Store";
import { useUserAuth } from "../../../hook/useAuth";

export const Sidebar = () => {
  const { User } = useUserAuth();
  const store = TriggerStore((state) => state);
  const { setSideAction, sidebarAction } = TriggerStore((state) => state);

  const userId = localStorage.getItem("R_M_uid");
  const UserData = User(userId as string);
  const Role  =  UserData.data?.roles[0]?.roleName??"";

  return (
    <div
      className={cn(
        sidebarAction ? "w-[15rem] p-2" : "w-14 px-2",
        "h-full bg-white border-r flex shadow-lg flex-col xl:justify-center py-2 relative transition-all duration-500"
      )}
    >
      <div
        className={cn(
          "flex flex-col gap-8 py-2 lg:mt-24 xl:mt-0 mt-24 md:mt-24 rounded-xl xl:justify-center",
          !sidebarAction ? "xl:border" : ""
        )}
      >
        {(Role === 'ADMIN' ? SidebarUpContent : SidebarUpContentForPaymentCollector).map((list: any) => {
          const isActive =
            (list.urlRoots as any)?.includes(
              (window.location as any).pathname
            ) ||
            (list.urlRoots as any)?.includes(
              (window.location as any).pathname.split("/")?.[1]
            );

          return (
            <NavLink
              to={list?.url}
              key={list.url}
              className={cn(
                !sidebarAction && "group",
                "bg-white hover:text-primary text-gray-400",
                isActive && sidebarAction ? "bg-blue-50" : "",
                sidebarAction ? "hover:bg-blue-50" : "",
                "flex w-full gap-2 items-center overflow-hidden px-2 cursor-pointer py-2 rounded-lg text-sm"
              )}
              onClick={() => store.setSideTrigger(false)}
            >
              <div className="transform transition duration-200 group-hover:scale-125">
                {isActive ? list.actionIcon : list.icon}
              </div>
              <span
                className={`whitespace-nowrap pl-2 transition-all font-mono duration-500 ${
                  isActive ? "text-primary" : "text-slate-600"
                } ${
                  !sidebarAction &&
                  " pl-0 opacity-0 translate-x-1 overflow-hidden pointer-events-none"
                }`}
              >
                {list?.title}
              </span>
              {/* <div
                className={`absolute left-48 bg-gray-700 text-white font-sans font-semibold whitespace-pre z-50 rounded-md drop-shadow-lg px-0 py-0 w-0 overflow-hidden group-hover:px-4 group-hover:py-1 group-hover:left-[4rem] group-hover:duration-300 group-hover:w-fit`}
              >
                {list?.title}
              </div> */}
            </NavLink>
          );
        })}
      </div>

      <div
        className={`rounded-full z-50 absolute right-0 translate-x-1/2 bottom-24 bg-primary delay-50 duration-500 ${
          sidebarAction ? "rotate-0" : "rotate-180"
        } px-2.5 w-7 h-7 py-1 cursor-pointer xl:block hidden`}
        style={{
          zIndex: "100",
        }}
        onClick={() => setSideAction(!sidebarAction)}
      >
        <MdArrowBackIos className="w-4 h-5 text-white" />
      </div>
    </div>
  );
};
